// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { Button, If } from "@hex-insights/core";
import {
	AddSubFormButtonRenderProps,
	BooleanField,
	DateTimeField,
	Form,
	FormType,
	SubFormField,
	SubFormRenderProps,
	TextField,
} from "@hex-insights/forms";
import { MediaAttachmentFormValues, MessageFormValues, MessageTopicFormValues } from "../../FormUtilities";
import { MediaAttachmentForm } from "../MediaAttachment";
import { MessageGroupSelectField } from "../MessageGroup";
import { MessageTopicForm } from "../MessageTopic";
import { BaseFieldProps } from "../shared";
import { UserSelectField } from "../User";

/**
 * Generic props for fields of the Message model.
 */
type FieldProps<K extends keyof MessageFormValues.Base = keyof MessageFormValues.Base> = BaseFieldProps<
	Pick<MessageFormValues.Base, K>
>;

/**
 * Generic props for fields of the Message model that only appear in the create form.
 */
type CreateFieldProps<K extends keyof MessageFormValues.Create = keyof MessageFormValues.Create> = BaseFieldProps<
	Pick<MessageFormValues.Create, K>
>;

/**
 * Generic props for fields of the Message model that only appear in the detail form.
 */
type DetailFieldProps<K extends keyof MessageFormValues.Detail = keyof MessageFormValues.Detail> = BaseFieldProps<
	Pick<MessageFormValues.Detail, K>
>;

/**
 * Field component for the `createdAt` field of the Message model.
 */
export function CreatedAt({ formState, ...props }: DetailFieldProps<"createdAt">) {
	return (
		<DateTimeField
			formState={formState}
			name="createdAt"
			optional={FormType.isCreate(formState.formType)}
			precision="minute"
			{...props}
		/>
	);
}

/**
 * Field component for the `body` field of the Message model.
 */
export function Body({ formState, ...props }: FieldProps<"body">) {
	return <TextField formState={formState} name="body" multiLine optional {...props} />;
}

/**
 * Field component for the `lastEditedAt` field of the Message model.
 */
export function LastEditedAt({ formState, ...props }: DetailFieldProps<"lastEditedAt">) {
	return <DateTimeField formState={formState} name="lastEditedAt" optional precision="minute" {...props} />;
}

/**
 * Field component for the `isRemoved` field of the Message model.
 */
export function IsRemoved({ formState, ...props }: DetailFieldProps<"isRemoved">) {
	return <BooleanField formState={formState} name="isRemoved" {...props} />;
}

export namespace Author {
	export type SelectProps = DetailFieldProps<"authorID"> &
		Omit<UserSelectField.SelectProps<MessageFormValues.Detail>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `author` edge of the Message model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <UserSelectField.Select formState={formState} name="authorID" {...props} />;
	}
}

export namespace MediaAttachments {
	/**
	 * SubForm field component for the `mediaAttachments` edge of the Message model.
	 */
	export function SubForm({ formState, ...props }: CreateFieldProps<"mediaAttachments">) {
		return (
			<SubFormField
				formState={formState}
				name="mediaAttachments"
				blankItem={MediaAttachmentFormValues.blankItemInMessage}
				{...props}
			>
				{SubForm.SubForm}
				{SubForm.AddButton}
			</SubFormField>
		);
	}

	SubForm.SubForm = function ({
		formState,
		onRemoveClick,
	}: SubFormRenderProps<MediaAttachmentFormValues.CreateInMessage>) {
		return (
			<Form.Column>
				<Button variant="tertiary" size="small" onClick={onRemoveClick} disabled={formState.disabled}>
					Remove Media Attachment
				</Button>
				<MediaAttachmentForm.CreateFieldsInMessage formState={formState} />
			</Form.Column>
		);
	};

	SubForm.AddButton = function ({
		onClick,
		disabled,
	}: AddSubFormButtonRenderProps<
		Pick<MessageFormValues.Create, "mediaAttachments">,
		MediaAttachmentFormValues.CreateInMessage
	>) {
		return (
			<Button variant="tertiary" size="small" onClick={onClick} disabled={disabled}>
				Add Media Attachment
			</Button>
		);
	};
}

export namespace MessageGroup {
	export type SelectProps = FieldProps<"messageGroupID"> &
		Omit<MessageGroupSelectField.SelectProps<MessageFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `messageGroup` edge of the Message model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <MessageGroupSelectField.Select formState={formState} name="messageGroupID" {...props} />;
	}
}

export namespace MessageTopic {
	/**
	 * SubForm field component for the `messageTopic` edge of the Message model.
	 */
	export function SubForm({ formState, ...props }: CreateFieldProps<"messageTopic">) {
		return (
			<SubFormField
				formState={formState}
				name="messageTopic"
				blankItem={MessageTopicFormValues.blankItemInMessage}
				maxItems={1}
				{...props}
			>
				{SubForm.SubForm}
				{SubForm.AddButton}
			</SubFormField>
		);
	}

	SubForm.SubForm = function ({
		formState,
		onRemoveClick,
	}: SubFormRenderProps<MessageTopicFormValues.CreateInMessage>) {
		return (
			<Form.Column>
				<Button variant="tertiary" size="small" onClick={onRemoveClick} disabled={formState.disabled}>
					Remove Message Topic
				</Button>
				<MessageTopicForm.CreateFieldsInMessage formState={formState} />
			</Form.Column>
		);
	};

	SubForm.AddButton = function ({
		onClick,
		disabled,
		canAddItem,
	}: AddSubFormButtonRenderProps<
		Pick<MessageFormValues.Create, "messageTopic">,
		MessageTopicFormValues.CreateInMessage
	>) {
		return (
			<If condition={canAddItem}>
				<Button variant="tertiary" size="small" onClick={onClick} disabled={disabled}>
					Add Message Topic
				</Button>
			</If>
		);
	};
}
